import { render, staticRenderFns } from "./EmfFlowUpDataLastRecordList.vue?vue&type=template&id=5f9fb050"
import script from "./EmfFlowUpDataLastRecordList.vue?vue&type=script&lang=js"
export * from "./EmfFlowUpDataLastRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports